import { Col, Row } from "@commonlibs";
import { ImageUploadLabeledTypes } from "./ImageUploadLabeled.types";
import TextFieldLabel from "../../TextField/TextFieldLabel/TextFieldLabel";
import { ImageUploadRoot } from "./ImageUploadLabeled.styles";

function ImageUploadLabeled({ alt, label, showDelete = false, onChange, value, disabled, uploadPath, uploadFn, onError }: ImageUploadLabeledTypes) {
    return (
        <Col style={{ width: "100%" }} gap={7}>
            {label && <TextFieldLabel label={label} />}
            <Row gap={20} alignItems="center">
                <ImageUploadRoot
                    showDelete={showDelete}
                    style={{ width: "100%" }}
                    size="xs"
                    alt={alt}
                    showControllers
                    controllersPosition="external"
                    value={value}
                    onChange={(v) => onChange?.(typeof v === "string" ? v : v?.[0])}
                    disabled={disabled}
                    uploadPath={uploadPath}
                    uploadFn={uploadFn}
                    onError={onError}
                />
            </Row>
        </Col>
    );
}

export default ImageUploadLabeled;
